<template>
  <div class="agreement">
    <h2 class="center">
      <strong>统统付服务协议</strong>
    </h2>
    <p class="sp_cl">
      欢迎使用统统付服务，统统付服务是由商盟商务服务有限公司（以下简称“统统付”或“本公司”）向统统付用户（以下简称“您”或“用户”）提供的代收付款的资金转移服务（以下简称“统统付服务”）。
      <strong>为了保障您的权益，请您确认已于注册、使用统统付服务前，已经详细阅读了本服务协议的所有内容。对于您可能更为关注的协议内容，已采用粗体字进行标注，提请您完整理解这些内容。</strong>
    </p>
    <p class="sp_cl">
      <strong>第一章 总则</strong>
    </p>
    <p class="sp_cl">
      <strong>第1条 您注册成为“统统付”用户的行为，即表示您已阅读、理解并同意接受本服务协议之所有内容。</strong>
    </p>
    <p class="sp_cl">
      <strong>第2条 统统付服务协议可由本公司进行修改，如我们对本协议进行修改，我们将通过本公司网站公告的方式提前予以公布，变更后的协议在公告届满30日起生效。</strong>
    </p>
    <p class="sp_cl">
      <strong>第3条 您在使用统统付服务之前，应仔细阅读本服务协议。如您不同意本服务协议及/或本公司对其进行的修改，您可以主动停用或取消统统付服务；您一旦使用统统付服务，即视为您已了解并完全同意本服务协议各项内容，包括本公司对服务协议所做的修改，并成为统统付用户。</strong>
    </p>
    <p class="sp_cl">第4条 我们会以网站公告、电子邮件、发送短信、电话、站内信或客户端通知等方式向您发送通知，例如通知您交易进展情况，或者提示您进行相关操作，请您及时予以关注。</p>
    <p class="sp_cl">第5条 如您所属的国家或地区排斥本服务条款内容之全部或部分内容，则您应立即停止使用统统付服务。</p>
    <p class="sp_cl">第6条 相关定义</p>
    <p class="sp_cl">（1）账号：指您通过统统付平台或与统统付合作的平台使用统统付支付服务时所使用的账号。您可以使用统统付平台账号或与统统付合作的平台账号直接登录统统付。</p>
    <p
      class="sp_cl"
    >（2）账户：指在您取得用户标识并通过身份验证后，我们为您开立的账户。如您完成相应身份验证，则可使用更多的服务，为您开通支付账户。除本协议另有约定外，支付账户持有人可以使用与支付相关的服务。与统统付合作的平台中的“钱包”中的支付有关服务，均为统统付向您提供，您以同一手机号绑定的上述账户，均为同一账户。您通过与统统付合作平台使用“钱包”功能时，即视为您不可撤销的同意统统付合作平台将您的信息提供至统统付。</p>
    <p
      class="sp_cl"
    >（3）统统付合作平台：指与统统付合作的第三方开发的支持统统付账户登录名登录的任何网站及其各种移动客户端应用程序。通过统统付合作平台的账户，也可直接登录统统付账户。</p>
    <p class="sp_cl">（4）有权机关：指依照法律法规等有权要求采取查询、冻结或扣划资金等措施的单位，包括但不限于公安机关、检察院、法院、海关、税务机关等。</p>
    <p class="sp_cl">（5）有权机关冻结：指按照前述有权机关要求进行的冻结。被冻结余额不能用于支付、提现或转账等，被冻结账户可能无法登录、使用。</p>
    <p class="sp_cl">（6）限制：指除有权机关冻结情况之外，用户标识或账户部分或全部功能不能使用，以及用户标识或账户相关资产、账户余额、第三方提供的授信额度不能使用。</p>
    <p class="sp_cl">（7）止付：指账户余额不能使用的限制措施，例如不能用于支付、提现或转账等服务。</p>
    <p
      class="sp_cl"
    >（8）余额服务：指基于支付账户余额可以使用的充值、消费、收款、转账等服务。余额服务的功能及收付款额度除按本协议约定外，还将按照《非银行支付机构网络支付业务管理办法》及其他监管规定进行调整。</p>
    <p
      class="sp_cl"
    >（9）收付款服务是指我们为您提供的代为收取或代为支付款项的服务。通过代为收取款项服务，您可以收到他人向您支付的款项。具体是指自您委托我们将您银行卡内的资金充值到您的账户或委托我们代为收取第三方向您支付的款项之时起，至根据您的指令将该等款项的全部或部分实际入账到您的银行账户或支付账户之时止（含提现）的整个过程。通过代为支付款项服务，您可以支付款项给您指定的第三方。具体是指自款项从您指定账户出账之时起，至我们根据您或有权方给出的指令将上述款项的全部或部分入账到第三方的银行账户或支付账户之时止的整个过程；或自您根据本协议委托我们将您银行卡的资金划转到您或他人的支付账户或自您因委托我们代为收取相关款项并入账到您的支付账户之时起，至委托我们根据您或有权方给出的指令将上述款项的全部或部分入账到第三方的银行账户或支付账户之时止的整个过程。</p>
    <p class="sp_cl">
      <strong>第二章 声明与承诺</strong>
    </p>
    <p class="sp_cl">第7条 在使用“统统付”服务前，您确认并同意以下事项：</p>
    <p class="sp_cl">
      <strong>（1）本公司不向未满16周岁的自然人，没有完全民事权利能力或民事行为能力的自然人，法人或其他组织提供服务。本公司也不鼓励上述群体或组织使用统统付服务。本公司同时强烈请求上述群体或组织不要向本公司提交任何个人信息。</strong>
    </p>
    <p class="sp_cl">
      <strong>（2）为了注册统统付服务，您必须向本公司提交您的真实、完整、准确的身份信息，包括但不限于名称、姓名、电子邮件地址等。同时您确认对提交的信息的真实性、完整性、准确性负责。若因法律法规或监管要求变动，本公司将按最新要求另行确定用户注册、使用统统付应提供的身份信息。</strong>
    </p>
    <p class="sp_cl">（3）您同意，尽管本公司会尝试提醒您关于此类操作或告知您后续处理方式，本公司并不对任何由于您提供资料有误而导致无法通知您相关信息的情况负责。</p>
    <p class="sp_cl">（4）统统付协议项下任何权利或义务，都不得在未经本公司同意的情况下被出售或转移到第三方个人或实体。</p>
    <p class="sp_cl">
      <strong>（5）任何您与本公司之间的电子邮件、短信、电子指令形式的沟通、交互都被视为有效沟通。</strong>
    </p>
    <p class="sp_cl">
      <strong>第8条 您承诺遵守中华人民共和国及其您所在国或地区的法律、法规及一切适用于互联网的国际惯例的规定，您同意不利用统统付服务进行任何违法或不正当的活动，也不得以非法方式使用统统付服务，包括但不限于下列行为：</strong>
    </p>
    <p class="sp_cl">
      <strong>（1）违反法律法规、规章制度、政府文件或合同约定：</strong>
    </p>
    <p class="sp_cl">
      <strong>i. 侵犯第三方的著作权、专利、商标、商业秘密或其它专有权利、公共利益和隐私；</strong>
    </p>
    <p class="sp_cl">
      <strong>ii. 侮辱或者诽谤他人，侵害他人合法权益；</strong>
    </p>
    <p class="sp_cl">
      <strong>iii. 进行与交易主体宣称的交易内容不符的交易，或不真实的交易；</strong>
    </p>
    <p class="sp_cl">
      <strong>iv. 提供赌博信息或以其他方式引诱他人参与赌博；</strong>
    </p>
    <p class="sp_cl">
      <strong>v. 从事不法交易行为，如洗钱、非法套现、诈骗、恐怖融资、赌博、传销、贩卖枪支、毒品、禁药、盗版软件、淫秽物品或其他违禁物及交易等；</strong>
    </p>
    <p class="sp_cl">
      <strong>vi. 违反依法律或合约所应负之保密义务；</strong>
    </p>
    <p class="sp_cl">
      <strong>vii. 国家法律、行政法规禁止的其他内容。</strong>
    </p>
    <p class="sp_cl">
      <strong>（2）为任何非法目的而使用统统付服务：</strong>
    </p>
    <p class="sp_cl">
      <strong>i. 冒用他人名义使用统统付服务；</strong>
    </p>
    <p class="sp_cl">
      <strong>ii. 使用无效信用卡号码，或未经授权使用他人信用卡号码进行交易；</strong>
    </p>
    <p class="sp_cl">
      <strong>iii. 非法使用他人银行账号或使用无效银行账号进行交易；</strong>
    </p>
    <p class="sp_cl">
      <strong>iv. 利用统统付服务进行无真实交易背景的虚假交易；</strong>
    </p>
    <p class="sp_cl">
      <strong>v. 被本公司、人民银行、发卡银行或收单银行、清算组织认定为对银行卡滥用的行为，属于违反《银行卡业务管理办法》的行为，或利用信用卡发卡银行所提供的授信额度进行套现行为。</strong>
    </p>
    <p class="sp_cl">
      <strong>（3）危害计算机信息网络安全：</strong>
    </p>
    <p class="sp_cl">
      <strong>i. 从事任何可能含有电脑病毒或是可能侵害统统付服务系统、资料的行为；</strong>
    </p>
    <p class="sp_cl">
      <strong>ii. 故意制作、传播计算机病毒等破坏性程序；</strong>
    </p>
    <p class="sp_cl">
      <strong>iii. 未经允许，进入计算机信息网络或者使用计算机信息网络资源；</strong>
    </p>
    <p class="sp_cl">
      <strong>iv. 未经允许，对计算机信息网络功能进行删除、修改或者增加；</strong>
    </p>
    <p class="sp_cl">
      <strong>v. 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加；</strong>
    </p>
    <p class="sp_cl">
      <strong>vi. 其他危害计算机信息网络安全的行为。</strong>
    </p>
    <p class="sp_cl">
      <strong>（4）或本公司有正当理由认为您有不适当的其他行为。</strong>
    </p>
    <p class="sp_cl">
      <strong>本公司怀疑您进行了本条规定的违约行为或根据相关法律法规或有权机关的要求，或您的用户标识或账户操作、资金流向等存在异常，或您的用户标识或账户可能产生风险，或他人向您账户错误汇入资金等导致您可能存在不当获利，或您遭到他人投诉，或您可能错误地操作他人用户标识或账户，或者将他人用户标识或账户进行了身份验证时，有权对您的用户标识或/账户进行调查。您理解并同意，您的用户标识或/账户将可能被暂停或终止提供服务，并限制您所使用的产品或服务功能（比如对用户标识或/及账户名下的款项和在途交易采取止付、取消交易、调账、限制提现等限制措施，或对交易的方式、规模、频率等进行限制）。您理解并同意本公司不会就账户的临时锁定以及锁定提供任何赔偿或者补偿。</strong>
    </p>
    <p class="sp_cl">
      <strong>第9条 对于您因违反本协议条款，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，您同意赔偿本公司及其合作公司、关联公司，并使之免受损害。</strong>
    </p>
    <p class="sp_cl">
      <strong>第10条 您承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在本公司首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，您应给予本公司等额的赔偿；若导致了本公司的合作伙伴或关联公司损害的，您应对该损害予以弥补。</strong>
    </p>
    <p
      class="sp_cl"
    >第11条 支付账户所记录的资金余额不同于您本人的银行存款，不受《存款保险条例》保护，其实质为您委托我们保管的、所有权归属于您的预付价值。该预付价值对应的货币资金虽然属于您，但不以您本人名义存放在银行，而是以我们的名义存放在中国人民银行专门账户中，并且由我们向中国人民银行发起资金调拨指令。</p>
    <p
      class="sp_cl"
    >第12条 统统付接受信息发布方的委托进行信息发布，仅对发布的信息承担表面审查责任，不对信息的准确、完整、合法性做出任何陈述和保证，也不承担任何责任，用户应依其独立判断做出决策，并自行承担其决策所产生的全部风险，用户无权据此向统统付提出任何法律主张。用户与交易对方之间因交易发生的或与交易有关的任何纠纷，应由纠纷各方自行解决，统统付不承担任何交易风险及法律责任。</p>
    <p class="sp_cl">第13条 如在统统付网站/客户端上以页面标明或其他方式表明相关服务系由第三方提供，您在使用该服务过程中如有疑问或发生纠纷，请您与第三方协商解决。</p>
    <p class="sp_cl">第三章 统统付账号的注册及密码安全</p>
    <p
      class="sp_cl"
    >第14条 您通过使用统统付平台账号或与统统付合作的平台的账号登录统统付，即可使用部分支付服务；也可以在未经注册的情况下使用部分统统付的服务。您还可以进一步申请并通过统统付验证后取得支付账户，使用更多服务。具体验证方式以统统付提示为准。以此账号查询或计算用户的预付、预收或应收、应付金额。</p>
    <p
      class="sp_cl"
    >第15条 您应自行设置统统付平台账号或与统统付合作的平台账号的登录密码和支付密码，并予以妥善保管。您的支付账户将根据您的账号进行配置并进行关联，不能单独使用；若您的账号注销，则与其关联的支付账户也随之注销，使得您无法通过该账号使用本服务。</p>

    <p class="sp_cl">
      <strong>第16条 我们要求您不对其他任何人或第三方告知或分享您的密码或其他可识别信息。您将对任何向第三方透露密码之行为，及其可能造成的影响负责。</strong>
    </p>
    <p class="sp_cl">第17条 本公司不会以电子邮件方式要求您提供密码或敏感信息。</p>
    <p
      class="sp_cl"
    >第18条 当您发现您的账户、密码被盗，或您账户发生未经授权的操作时，您承诺在第一时间以有效的形式通知本公司。您了解并接受当此类事件发生时，为保护您的账户安全，本公司将对您账户实行临时性暂停服务操作。</p>
    <p
      class="sp_cl"
    >第19条 因您主观过错或者过失导致的任何损失由您自行承担，该过错或者过失包括但不限于：不按照交易提示操作，未及时进行交易操作，遗忘密码，泄漏密码，密码被他人破解，您使用的计算机被他人侵入等情况。</p>
    <p class="sp_cl">第20条 任何在接受通知前发生的因您主观过失导致的未经授权交易或造成的其他损失，本公司都不承担任何责任，除非可证明本公司存在重大过失。</p>
    <p class="sp_cl">
      <strong>第四章 服务内容</strong>
    </p>
    <p
      class="sp_cl"
    >第21条 统统付支付服务是统统付向您提供的非金融机构支付服务，是受您委托代您收款或付款的资金转移服务、交易信息的发布、交易的管理服务、以及交易的辅助服务。本公司提供的服务包括不限于：</p>
    <p class="sp_cl">（1）保管功能：统统付将您充值、代收付款项保存在以本公司名义在中国人民银行开立的“备付金集中存管账户”内。</p>
    <p class="sp_cl">（2）代收:接受您的要求代为收取其他第三方向您支付的各类款项。</p>
    <p
      class="sp_cl"
    >（3）代付：经由您的授权，通过您或本公司合作第三方技术接口对接方式向您指定的银行账户、单位结算卡支付指定金额的本公司代为保管或代收的款项。如非经法律程序或者非由于本条款约定事项之出现，此等支付是不可逆转的。</p>
    <p class="sp_cl">（4）充值：经由您授权，将您本人或本单位/公司银行账号内的资金划转到您的统统付账户。</p>
    <p class="sp_cl">（5）提现：经由您授权，将您统统付账户内余额划转至您本人或本单位/公司绑定的银行账号。</p>
    <p class="sp_cl">（6）转账：您可以委托我们将本公司代您保管或代收的款项转至您指定的收款方统统付账户或银行账号。</p>
    <p
      class="sp_cl"
    >（7）查询功能：本公司将对您在本系统中的所有操作进行记录，不管该操作之目的最终是否实现，您可以在本系统中实时进行查询，并可以此为基础与您的账号名下的交易记录进行核对查询，如您认为数额有误，则本公司将向您提供本公司已按照您的指示收付款的记录，您了解并同意您最终能够收到款项的责任是由您登记的银行账户对应的银行提供的，您需向该银行请求查证。</p>
    <p class="sp_cl">第22条 您认可并同意按照如下流程进行涉及银行卡支付的服务：</p>
    <p
      class="sp_cl"
    >(1) 您通过统统付与商户进行商品或服务交易并首次通过本服务进行付款时，只需输入银行卡卡号、姓名、证件号、银行预留手机号等信息（您所需提供的信息因银行不同会略有增减），点击“下一步”或提示进入下一界面的提示按钮，您的预留手机号上将收到手机校验码，您输入正确的手机校验码，即完成首次支付。</p>
    <p class="sp_cl">(2) 您应选择设置“支付密码”，支付密码一旦设置，即您已将支付账户与您的上述银行相卡联关。</p>
    <p
      class="sp_cl"
    >(3) 您输入您的相关信息或支付密码并提交后即视为您确认交易及交易金额（您使用统统付的免密支付或代扣服务二次支付时，无需您输入前述信息或支付密码），并已不可撤销地向统统付发出指令，统统付有权根据您的指令委托银联从您提交支付的银行卡中将您确认的交易资金予以划扣。届时您不应以未开通本服务或非本人意愿交易等原因要求统统付及/或交易银行退款或承担其他责任。</p>
    <p
      class="sp_cl"
    >第23条 您在此确认，任何您向本公司发送的支付或收款请求，无论在统统付网站或第三方网站上，如果其流程符合“统统付”服务协议所指明之流程，都将视为您本人的操作，并成为不可撤销的指令。</p>
    <p class="sp_cl">
      <strong>第24条 对于违反统统付交易规则的交易，本公司保留直接自您的账号名下的余额中扣回款项及禁止您要求支付此笔款项之权利。此款项若已汇入您的银行账户，您同意本公司有向您事后索回之权利。</strong>
    </p>
    <p class="sp_cl">第25条 本公司保留拒绝您将统统付服务用于任何未经本公司书面同意的用途的权利。</p>
    <p
      class="sp_cl"
    >第26条 您同意基于运行和交易安全的需要，本公司在没有提前通知您的情况下，可以新增新的服务，或暂时停止提供或者限制部分服务功能。只要您仍然使用统统付服务，表示您仍然同意本条款或者本条款修正后的条款。</p>
    <p class="sp_cl">
      <strong>第27条 统统付有权纠正因系统故障或其他任何原因导致的处理错误；如该错误导致您款项实收金额大于应收金额，您应根据统统付向您发出的有关纠正错误通知的具体要求返还多收的款项或进行其他操作；统统付也有权直接从您的金融账户扣回您多收的款项或以其他任何方式向您索回；您因处理错误而多付或少付的款项均不计利息，由此产生的损失由您承担，统统付不因此承担任何法律责任。</strong>
    </p>
    <p class="sp_cl">第28条 用户通过统统付进行各项交易时，对于用户未按照本协议或适用于该等交易的任何交易规则或公告要求而进行操作所导致的任何后果，统统付不承担任何责任。</p>
    <p class="sp_cl">
      <strong>第29条 用户理解并同意，统统付对在统统付合作平台或本网站或客户端上进行的投资、借款、信用卡等交易行为的后果不承担任何责任，统统付无法也无义务保证用户在进行交易之后能够实际完成交易或取得相关的收益，用户应自行承担由于交易所产生的损失。</strong>
    </p>
    <p class="sp_cl">第30条 您使用我们的服务购买金融类产品时，为了您的利益，建议您仔细阅读金融类产品的协议以及页面提示，确认销售机构及产品信息，谨慎评估风险后再购买。</p>
    <p
      class="sp_cl"
    >第31条 当您向商家付款时，商家会将您的支付金额、支付对象传输给我们以确认是否是您的真实意思表示。按照法律法规及监管规定，我们需要对商家进行管理，如识别、防止其套取现金或欺诈，商家会将购买商品、收货地址、联系方式提供给我们。</p>
    <p class="sp_cl">第32条 为了您的交易安全，在使用统统付服务时，请您事先自行核实交易对方的身份信息并谨慎决定是否使用统统付服务与对方进行交易。</p>
    <p class="sp_cl">第33条 本协议项下涉及的资金转移均通过银行、和清算机构来实现，您接受资金在转移途中产生的合理时间。</p>
    <p class="sp_cl">第34条 账户仅限本人使用，您需充分了解并清楚知晓出租、出借、出售、购买账户的相关法律责任和惩戒措施，承诺依法依规开立和使用本人账户。</p>
    <p class="sp_cl">第35条 我们的服务有赖于系统的准确运行及操作。若出现系统差错、故障、您或我们不当获利等情形，您同意我们可以采取更正差错、扣划款项等适当纠正措施。</p>
    <p
      class="sp_cl"
    >第36条 统统付有权根据《非金融机构支付服务管理办法》、《非银行支付机构网络支付业务管理办法》等相关规定对您的支付账户功能和交易额度进行限制和调整。当您的身份校验和交易校验情况符合（或不满足）相关规定时，统统付有权对您拥有的所有支付账户采取开启（或关闭）相关功能、增加（或降低）交易额度的措施，并要求您补充提交相关信息。若您拒不提交，或提交的信息仍不符合相关规定，统统付有权对您暂停、限制或终止服务。</p>
    <p class="sp_cl">
      <strong>第五章 身份验证</strong>
    </p>
    <p class="sp_cl">
      <strong>第37条 您在注册、使用我们服务的过程中，您需提供合法、真实、有效、准确并完整的资料（根据具体验证需要，可能包括身份证、户口本、护照、营业执照等证明材料、联系方式、从事职业、通讯地址、个人生物识别、实际控制人、受益所有人信息等）。为了能将账户资金变动及时通知到您，以及更好保障您的账户安全，如该等资料发生变更，请您及时通知我们。为了及时有效地验证您的信息（包括但不限于身份信息、账户信息、购汇额度等），根据法律法规及监管规定或我们认为有需要时，您同意我们可以把您的信息提供给第三方，也同意第三方可以把您的信息提供给我们，以便我们进行验证。您应确保统统付登录名、用户标识或账户绑定的电子邮箱或手机号均为您本人持有，如您占用了他人的电子邮箱或手机号的，为避免给电子邮箱或手机号持有人带来不便或不利影响，也为了您的资金安全，我们可能将该邮箱或手机号从您的用户标识或账户中删除并解除关联。</strong>
    </p>
    <p
      class="sp_cl"
    >第38条 统统付有权根据《反洗钱法》、《支付机构反洗钱和反恐怖融资管理办法》、《非银行支付机构网络支付业务管理办法》等相关规定采取有效方式对您进行客户身份识别，要求您提交包括但不限于您的姓名/名称、身份证号码、身份证件/营业执照副本影印件、手机号码、银行账户信息、学历信息、交通票务信息等身份信息、账户信息和其他相关信息，您在此授权统统付有权收集、保存您的信息/证件并自行或委托其他机构将您的信息传输至公安机关、金融机构、其他行政机关、企业、事业单位，以校验您信息的真实性，核实您的真实身份和安全验证，若统统付委托其他机构处理前述事项，受托机构将有权收集、保存、传输您的信息，我们将按照公司隐私政策规定妥善保存您的前述信息。若您要求变更身份信息或您身份信息/证件已过有效期，您应向我们及时更新您的信息/证件或其他必要文件，否则我们有权暂停为你提供支付服务。</p>
    <p
      class="sp_cl"
    >第39条 为了满足相关监管规定的要求，请您按照我们要求的时间提供您的身份信息以完成身份验证，否则您可能无法进行收款、提现、余额支付、购买理财产品等操作，且我们可能对您的账户余额进行止付或注销您的账户。</p>
    <p class="sp_cl">第40条 为了维护良好的网络环境，我们有时需要了解您使用统统付服务的真实背景及目的，如我们要求您提供相关信息或资料的，请您配合提供。</p>
    <p class="sp_cl">
      <strong>第41条 您需要自行承担您使用我们服务期间的货币贬值、汇率波动及收益损失等风险，您仅在我们代为收取或代为支付款项（不含被有权机关 冻结、止付或其他限制的款项）的金额范围内享有对该等款项支付、提现的权利，您对所有代为收取或代为支付款项产生的收益（如利息和其他孳息）不享有权利。我们就该代为收取或代为支付款项产生的收益（如利息和其他孳息）享有所有权。</strong>
    </p>
    <p class="sp_cl">第六章 服务费用</p>
    <p
      class="sp_cl"
    >第42条 使用统统付服务，将会产生相应的服务费用。具体服务费用以您使用我们服务时网站/客户端或产品页面上所列的收费方式为准；或通过您与我们达成的书面协议的形式约定。本公司保留制定与不时调整服务费用的权利。您同意我们有权自您委托我们办理相应服务时直接从您的款项中扣除相应的服务费。</p>
    <p class="sp_cl">
      <strong>第七章 暂停或终止您的使用</strong>
    </p>
    <p class="sp_cl">第43条 您明确理解和同意，在出现下述情况之一时，本公司有权暂停或终止您对统统付服务的使用，且无需事先通知，本公司不承担违约责任或其他任何赔偿责任：</p>
    <p class="sp_cl">（1）本公司有合理的依据证明您已经违反本服务协议或人民银行的规定；或</p>
    <p class="sp_cl">（2）本公司发现您有异常交易或发现您的交易涉嫌违法时； 或</p>
    <p class="sp_cl">（3）本公司认为必要之时。</p>
    <p class="sp_cl">
      <strong>第44条 本公司暂停、拒绝或终止您对统统付的使用后：</strong>
    </p>
    <p class="sp_cl">
      <strong>（1）在本公司暂停您的统统付服务后，若您修正违反协议的行为且向本公司书面保证不再违法本服务协议的规定后，本公司可视情况恢复您的统统付服务；</strong>
    </p>
    <p class="sp_cl">
      <strong>（2）在本公司终止您的统统付服务后，将关闭或删除您的账号及您账号中所有相关资料及档案，并将您滞留在统统付的全部资金退回到您的银行账户中。</strong>
    </p>
    <p class="sp_cl">第45条 符合以下条件的，您可以申请注销您的用户标识或支付账户：</p>
    <p class="sp_cl">（1）您仅能申请注销您本人的用户标识或账户，并依照我们的流程进行注销。</p>
    <p class="sp_cl">（2）您申请注销的用户标识或账户处于正常状态，即您的用户标识或账户的信息是最新、完整、正确的，且用户标识或账户未被采取止付、有权机关冻结等限制措施。</p>
    <p
      class="sp_cl"
    >（3）为了维护您和其他用户的合法利益，您申请注销的用户标识或账户，应当不存在未了结的权利义务或其他因为注销该账户会产生纠纷的情况，不存在未完结交易，没有余额，没有关联的资产。</p>
    <p
      class="sp_cl"
    >第46条 根据《非银行支付机构网络支付业务管理办法》规定，我们不得为金融机构，以及从事信贷、融资、理财、担保、信托、货币兑换等金融业务的其他机构开立支付账户。如您属于前述机构，且您持有支付账户的，则您同意按照我们的流程尽快将该支付账户内资金提现或通过转账等途径支用完毕，并授权我们将该支付账户注销，但您仍可使用我们基于银行账户向您提供的支付服务。</p>
    <p class="sp_cl">第六章 不可抗力及服务中断</p>
    <p class="sp_cl">第47条 统统付系统因下列不可抗力导致服务暂停或中断的，本公司不承担违约或赔偿责任：</p>
    <p class="sp_cl">（1）因台风、地震、海啸、洪水、停电、战争、恐怖袭击等，造成本公司统统付系统障碍不能提供服务的；</p>
    <p class="sp_cl">（2）黑客攻击；</p>
    <p class="sp_cl">（3）计算机系统遭到破坏、瘫痪或无法正常使用而导致信息或纪录的丢失；</p>
    <p class="sp_cl">（4）电信技术部门调整导致之重大影响；</p>
    <p class="sp_cl">（5）因政府管制而造成的暂时关闭；</p>
    <p class="sp_cl">（6）病毒侵袭；</p>
    <p class="sp_cl">（7）其他。</p>
    <p class="sp_cl">
      <strong>第48条 本公司需要定期或不定期地对提供统统付服务系统及其相关的设备进行升级、更新、检修或者维护，如因此类情况而造成网络服务在合理时间内的中断，本公司无需为此承担任何责任。</strong>
    </p>
    <p class="sp_cl">
      <strong>第七章 责任范围及责任限制</strong>
    </p>
    <p class="sp_cl">第49条 本公司无法保证用户所提交的信息的准确性、合法性和及时性，请您在交易过程中谨慎判断。</p>
    <p class="sp_cl">
      <strong>第50条 本公司无法保证统统付服务符合您的要求，或统统付服务零差错率等。</strong>
    </p>
    <p class="sp_cl">
      <strong>第51条 本公司不对合作伙伴所提供的服务质量及内容承担保证责任。</strong>
    </p>
    <p
      class="sp_cl"
    >第52条 本公司仅承担本服务协议明确约定的直接责任。除本协议另有规定外，在任何情况下，本公司对本协议所承担的违约赔偿责任总额不超过向您收取的当次统统付服务费用总额。</p>
    <p class="sp_cl">
      <strong>第八章 商标、知识产权的保护</strong>
    </p>
    <p
      class="sp_cl"
    >第53条 本公司及关联公司拥有本系统、应用、网站内所有资料及展现形式的知识产权，本系统、应用、网站所有的技术及程序均属本公司或关联公司所有，并未授权任何人使用。</p>
    <p
      class="sp_cl"
    >第54条 未经本公司许可，任何人不得擅自使用（包括但不限于：以非法的方式复制、传播、展示、镜像、上载、下载）、修改、传播本公司或关联公司的知识产权。否则，本公司将依法追究法律责任。</p>
    <p class="sp_cl">
      <strong>第九章 管辖</strong>
    </p>

    <p class="sp_cl">第55条 本服务协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</p>
    <p class="sp_cl">
      <strong>第56条 因本协议引起的或与本协议有关的任何争议，尽最大诚意进行友好协商，如果双方不能协商一致，则该争议由本公司所在地有管辖权的人民法院管辖。</strong>
    </p>
    <p class="sp_cl">
      <strong>第十章 其他</strong>
    </p>
    <p class="sp_cl">第57条 通知方式：</p>
    <p class="sp_cl">（1）拨打客服电话、向客服邮箱发送邮件、传真、EMS等方式均视为客户的有效通知。</p>
    <p class="sp_cl">
      <strong>（2）若通知以电子邮件形式发送，则有效通知日期以电子邮件系统发出时间为准；若通知及函件以传真方式传送，则有效通知日期以传真传送记录所显示的时间为准；若通知及函件以专人派送（包括特快专递）或挂号邮件发送时，则有效通知日期以收件方签收之日为准；以多种方式通知收件方的，则有效通知日期以最早的有效通知日期为准。本公司不保证您能够收到或者及时收到该邮件（或传真或挂号邮件），且不对此承担任何后果，因此，在交易过程中您应当及时登录到本网站查看和进行交易操作。因您没有及时查看和对交易状态进行修改或确认或未能提交相关申请而导致的任何纠纷或损失，本公司不负任何责任。</strong>
    </p>
    <p class="sp_cl">第58条 如果本服务协议条款中的部分条款被有管辖权的法院认定为违法，那么这些条款并不影响其他条款的有效性并将应用其他有效条款按最接近双方意图的可能而推定。</p>

    <p class="sp_cl">第59条 本公司未行使或执行本服务协议任何权利或规定，不构成对前述权利或权益之放弃。</p>
    <p
      class="sp_cl"
    >第60条 本协议由《统统付服务协议》条款及本网站或用户端已经发布的或将来可能发布并不时更新的各类文件，包括但不限于网站或用户端公告、交易规则、收费规则、产品说明书、风险提示、认购说明等文件。等本网站不时公示的各项规则组成，各项规则有约定，而本协议条款没有约定的，以各项规则约定为准。</p>
    <p class="sp_cl">第61条 如果您有任何的意见和建议，欢迎您与我们沟通反馈。我们的联系方式见下：</p>
    <p class="sp_cl">客服热线：400-700-8808</p>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped lang="less">
.agreement {
  text-align: left;
  padding: 20px;
  .sp_cl {
    margin-bottom: 8px;
  }
  .sp_rf {
    text-align: right;
  }
  .sp_underLine {
    text-decoration: underline;
  }
  .center {
    text-align: center;
    margin-bottom: 20px;
  }
}
</style>
